import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from './Button'

/**
 * Paylaşılan liste "Yenile" butonu (Reuse Mandate). Liste sorgusunu yeniden çeker; yüklenirken
 * spinner. Sade/toolbar görünümü: kenarlıksız (text), muted ikon+metin, hafif hover — arama kutusu
 * ve birincil aksiyonun yanında öne çıkmadan durur. Görünüm `.ui-refresh` ile (ui.css).
 *
 * <p><b>Spinner'ı buton KENDİ sahiplenir (kullanıcı bildirimi 2026-08-31).</b> Önceden çağıran
 * sayfalar `loading={list.isFetching}` geçiyordu; `isFetching` sorgunun HER çekiminde true olur —
 * kolon başlığına basıp sıralamak, sayfa değiştirmek, arama yazmak veya bir mutasyon sonrası
 * invalidate de dahil. Sunucu-taraflı sıralayan tablolarda (lazy DataTable) bu, kolona her
 * basıldığında Yenile'nin dönmesine ve pasifleşmesine yol açıyordu: kullanıcı kendi basmadığı bir
 * butonun çalıştığını görüyordu. Artık spinner yalnız <b>bu butonun başlattığı</b> çekim boyunca
 * döner — {@code onRefresh}'in döndürdüğü söz (promise) beklenir.</p>
 */
interface RefreshButtonProps {
  /**
   * Listeyi yeniden çeker. Promise döndürürse (ör. {@code () => list.refetch()}) spinner tam o
   * çekim boyunca döner; void dönen bir işleyicide buton hiç spinner göstermez — birden çok sorgu
   * tazeleniyorsa `Promise.all([...])` döndürün.
   */
  onRefresh: () => void | Promise<unknown>
}

export default function RefreshButton({ onRefresh }: Readonly<RefreshButtonProps>) {
  const { t } = useTranslation()
  const [busy, setBusy] = useState(false)

  const handleClick = () => {
    const result = onRefresh()
    // react-query `refetch()` reject ETMEZ (hatayı sorgu durumuna yazar) → `finally` yeterli.
    if (!(result instanceof Promise)) return
    setBusy(true)
    result.finally(() => setBusy(false))
  }

  return (
    <Button
      type="button"
      text
      icon="pi pi-refresh"
      label={t('common.refresh')}
      className="ui-refresh"
      onClick={handleClick}
      loading={busy}
    />
  )
}
